import { VeritoneFile } from '@redact-modules/mainPage/models';
import { CaseId, TDOId } from '@common-modules/universal/models/Brands';
import {
  createGraphQLFailureAction,
  createGraphQLSuccessAction,
} from '@helpers/callGraphQLApi';
import { createAction } from '@reduxjs/toolkit';
import { GlobalSettings } from '@common/state/modules/mediaDetails/models';
import type { CreateTdo } from 'veritone-types';

interface CREATE_TDO_VARIABLES {
  input: Partial<CreateTdo>;
  url: string;
  unsignedUrl?: string | null;
  error: string | undefined;
}

export const CREATE_TDO = createAction(
  'vtn-app-redact/CREATE_TDO',
  (
    payload: CreateTdoPayload,
    meta: {
      govQARequestId?: string;
      foiaXpressRequestId?: string;
      casepointRequestId?: string;
      nuixRequestId?: string;
      exterroRequestId?: string;
      callback?: () => void;
      caseId?: CaseId;
      settingsProfileId?: string;
    }
  ) => ({ payload, meta })
);

export const CREATE_TDO_SUCCESS = createGraphQLSuccessAction<
  CreateTdoSuccessPayload,
  CREATE_TDO_VARIABLES,
  true
>('vtn-app-redact/CREATE_TDO_SUCCESS');
export const CREATE_TDO_FAILURE = createGraphQLFailureAction(
  'vtn-app-redact/CREATE_TDO_FAILURE'
);

export interface CreateTdoPayload {
  readonly fileName?: string;
  readonly getUrl: string;
  readonly size?: number;
  readonly type?: string;
  readonly unsignedUrl?: string | null;
  readonly error?: string;
}

export interface CreateTdoSuccessPayload {
  readonly createTDO: {
    id: TDOId;
    name: string;
    status: 'downloaded' | 'recording' | 'recorded';
    details: JSON & {
      veritoneFile: VeritoneFile;
      settings?: GlobalSettings;
    };
  };
}

export const actionCreateTDO = (
  payload: CreateTdoPayload,
  govQARequestId?: string,
  foiaXpressRequestId?: string,
  casepointRequestId?: string,
  nuixRequestId?: string,
  exterroRequestId?: string,
  callback?: () => void,
  caseId?: CaseId,
  settingsProfileId?: string
) =>
  CREATE_TDO(payload, {
    govQARequestId,
    foiaXpressRequestId,
    casepointRequestId,
    nuixRequestId,
    exterroRequestId,
    callback,
    caseId,
    settingsProfileId,
  });
